(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
(function() {
  
  function supportsTransitions() {
    var b = document.body || document.documentElement,
      s = b.style,
      p = 'transition';

    if (typeof s[p] == 'string') {
      return true;
    } else {
      return false;
    }
  }
  
  var nativeAnimations,
      animation = {};
  
  var carousel = document.getElementById('SectionCarousel'),
      carouselSlides = document.getElementById('SectionCarouselSlides'),
      slides = document.querySelectorAll('.carousel__slides--item'),
      activeSlide = document.querySelector('.slide-is-active'),
      activeSlideImage = activeSlide.querySelector('.carousel__slides--img'),
      pictures = document.querySelectorAll('.carousel__slides--picture'),
      captions = document.querySelectorAll('.carousel__slides--caption'),
      cites = carousel.querySelectorAll('.carousel__slides--caption cite');
  
  if (supportsTransitions()) {
    init();
  }
  
  function init() {
    
    setAnimation();
    setEvents();
    lazyLoad();
  }
  
  function setAnimation() {
    if (typeof document.createElement('div').animate !== 'undefined') {
      nativeAnimations = true;
      animation.duration = parseInt(carousel.getAttribute('data-animation-duration'));
      animation.easing = carousel.getAttribute('data-animation-easing');
    } else {
      nativeAnimations = false;
      carousel.classList.add('css-transitions');
    }
  }
  
  function lazyLoad() {
    
    var active = document.querySelector('.slide-is-active'),
        prev = active.previousElementSibling,
        next = active.nextElementSibling;
    
    setSource(active);
    setSource(prev);
    setSource(next); 
  }
  
  function setSource(pictureElement) {
    
    if (pictureElement) {
      var source = pictureElement.querySelector('source[data-srcset]');
      
      if (source) {
        var dataSrc = source.getAttribute('data-srcset')
        source.setAttribute('srcset', dataSrc);
        source.removeAttribute('data-srcset');
      }
    }
  }
  
  function setEvents() {
    
    var buttons = carousel.querySelectorAll('.carousel-button'),
        i = 0,
        il = buttons.length;
    
    for (;i < il; i += 1) {
      buttons[i].addEventListener('click', slideClick, false);
    }
  }
  
  function slideClick(evt) {

    if (this.id === 'CarouselPrev') {
      setSlide ('prev');
    } else if (this.id === 'CarouselNext') {
      setSlide ('next');
    }
  }
  
  function setSlide(direction) {
    
    if (typeof direction === 'string') {
      
      var index = parseInt(carousel.getAttribute('data-stage')),
          oldIndex = index;
      
      slides[index - 1].classList.remove('slide-is-active');
      
      if (direction === 'prev') {
        index -= 1;
      } else if (direction === 'next') {
        index += 1;
      }
    }
    
    if (index === 0) {
      index = slides.length;
    } else if (index > slides.length) {
      index = 1;
    }
    
    slides[index - 1].classList.add('slide-is-active');
    carousel.setAttribute('data-stage', index);
    lazyLoad();
    
    if (nativeAnimations) {
      nativeAnimation(oldIndex, index);
    }

  }
  
  function nativeAnimation(oldIndex, newIndex) {
    
    var increment = -100 / (slides.length + 1);

    var animationObj = { 
      duration: animation.duration,
      easing: animation.easing,
      iterations: 1,
      fill: 'both'
    }

    carouselSlides.animate([
      { transform: 'translateX(' + ((oldIndex - 1) * increment) + '%)' }, 
      { transform: 'translateX(' + ((newIndex - 1) * increment) + '%)' }
    ], animationObj);
    
    pictures[oldIndex - 1].animate([
      { opacity: 1 }, 
      { opacity: 0.6 }
    ], animationObj);
    
    pictures[newIndex - 1].animate([
      { opacity: 0.6 }, 
      { opacity: 1 }
    ], animationObj);
    
    captions[oldIndex - 1].animate([
      { opacity: 1,
        transform: 'translateY(0px)'
      }, 
      { opacity: 0,
        transform: 'translateY(30px)'
      }
    ], animationObj);
    
    captions[newIndex - 1].animate([
      { opacity: 0,
        transform: 'translateY(30px)'
      }, 
      { opacity: 1,
        transform: 'translateY(0px)'
      }
    ], animationObj);
    
    cites[oldIndex - 1].animate([
      { opacity: 1,
        transform: 'translateY(0px)'
      }, 
      { opacity: 0,
        transform: 'translateY(30px)'
      }
    ], animationObj);
    
    cites[newIndex - 1].animate([
      { opacity: 0,
        transform: 'translateY(30px)'
      }, 
      { opacity: 1,
        transform: 'translateY(0px)'
      }
    ], animationObj);
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
